export const ERROR_PREFIX = "[@sidebase/nuxt-auth]";
